import React, { createContext, useState, useContext, useEffect } from 'react';
import { w3leTheme } from '../theme/w3leTheme';

// Create the context
const ThemeContext = createContext();

// Create a theme provider component
export const ThemeProvider = ({ children }) => {
  const [themeMode, setThemeMode] = useState(() => {
    // Try to get the theme from localStorage
    const savedTheme = localStorage.getItem('themeMode');
    return savedTheme || 'light';
  });
  
  // Effect to apply the theme class to the body
  useEffect(() => {
    document.body.classList.remove('light-mode', 'dark-mode');
    document.body.classList.add(`${themeMode}-mode`);
    
    // Save to localStorage
    localStorage.setItem('themeMode', themeMode);
  }, [themeMode]);
  
  // Toggle theme function
  const toggleTheme = () => {
    setThemeMode(prevMode => (prevMode === 'light' ? 'dark' : 'light'));
  };
  
  // Use W3LE theme with current mode
  const theme = w3leTheme(themeMode);
  
  // Context value
  const contextValue = {
    themeMode,
    toggleTheme,
    theme
  };
  
  return (
    <ThemeContext.Provider value={contextValue}>
      {children}
    </ThemeContext.Provider>
  );
};

// Custom hook to use the theme context
export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export default ThemeContext;